var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaintImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 68,
    viewBox: "0 0 114 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7402 49.2158C26.0833 25.4802 46.4168 -10.4623 44.5862 35.6526C44.5859 43.5644 46.361 54.3894 62.3714 35.6526C69.1568 27.7117 82.7308 30.9544 83.2768 43.905C83.658 52.9471 87.0777 60.0664 100.802 49.2158",
    stroke: "#E3E3E3",
    strokeWidth: 25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaintImg);
export default __webpack_public_path__ + "static/media/PaintImg.a98979237b15885429e7d19468cf95e0.svg";
export { ForwardRef as ReactComponent };